import { isSupportedLineItem, isContactLensesBundleOrderLineItem, isGlassesBundleOrderLineItem, isNonPrescriptionBundleOrderLineItem } from "../../../mappers/view/utils/Orders/mappers/view/utils/order-line-item-product-type-guards.js";
const isLineItemReorderable = (orderLineItem) => isSupportedLineItem(orderLineItem) && !!orderLineItem.product.currentProduct?.published && !isContactLensesBundleOrderLineItem(orderLineItem) && !isGlassesBundleOrderLineItem(orderLineItem) && !isNonPrescriptionBundleOrderLineItem(orderLineItem);
const isEveryLineItemReorderable = (orderLineItem) => orderLineItem.every(isLineItemReorderable);
export {
  isEveryLineItemReorderable,
  isLineItemReorderable
};
//# sourceMappingURL=is-line-item-reorderable.js.map
